import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/translation/missing/translation.missing.query.gql"
import type {
  TranslationMissingQuery,
  TranslationMissingQueryVariables,
} from "@/v2-backoffice-client/translation/missing/__types__/translation.missing.query"

type Options = QueryHookOptions<
  TranslationMissingQuery,
  TranslationMissingQueryVariables
>

export function useTranslationMissingQuery(options?: Options) {
  return useQuery<TranslationMissingQuery, TranslationMissingQueryVariables>(
    query,
    options,
  )
}
